export * from "@tt-app/constants/content/vuex";
export * from "@tt-app/constants/content/cefr-j";

export enum CONTENT_TYPE {
  chapter = 2,
  section = 3,
  exercise = 11
}
